import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';
import type {IEvent} from '../types/IEvent';
import {createTZDate, displayFullDateTime, timezoneName} from '../utils/date';


export const selectMeetingDateTime = (
  state: IRootMachineSnapshot,
  language: string,
) => {
  const eventDetails = state.context.eventDetails as IEvent;
  if (!eventDetails?.event_start) {
    return '';
  }

  const timezone = state.context.timezone as string;
  const date = createTZDate(eventDetails?.event_start, timezone);
  const dateTime = displayFullDateTime(date, language);
  const formattedTimezone =
    timezoneName(eventDetails?.event_start, language) || '';

  return `${dateTime}, ${formattedTimezone}`;
};
